import React from "react";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import styles from "./RemoveOrgFromAccountModal.module.scss";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

type RemoveOrgFromAccountModalProps = IModalInstance<boolean>;

export const RemoveOrgFromAccountModal: React.FC<RemoveOrgFromAccountModalProps> = ({ closeModal }) => {
  const { t } = useTranslation();
  return (
    <BaseModal
      className={classnames(styles.modal)}
      bodyClassName={styles.body}
      closeOnClickOutside={false}
      closeOnEscape={true}
      closeModal={() => closeModal()}
      testId={"unassign-org-modal"}
      header={<ModalHeader closeModal={() => closeModal()}>{t(`account_admin.account_orgs.remove_org_modal.title`)}</ModalHeader>}
    >
      <div className={styles.text}>{t(`account_admin.account_orgs.remove_org_modal.description`)}</div>
      <ModalButtons testId={"modal-buttons-submit-button"} onCancel={() => closeModal()} isSubmitDisabled={false} onSubmit={() => closeModal(true)} />
    </BaseModal>
  );
};
